import React from 'react';

export default function AffiliateHome() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-950 via-black to-slate-950 text-slate-100 p-4">
      <div className="flex flex-col items-center max-w-xl w-full bg-white/5 border border-white/10 rounded-2xl p-10 shadow-lg">
        <img src="/logo_svg.svg" alt="Hiperyon Logo" className="h-24 w-24 mb-6" />
        <h1 className="text-4xl font-bold mb-4 text-center">Welcome to the Hiperyon Affiliate Space</h1>
        <p className="text-lg text-slate-300 mb-6 text-center">
          Earn money by recommending Hiperyon to your audience!<br />
          Track your conversions, earnings, and share your personalized link to benefit from our affiliate program.
        </p>
        <a
          href="/affiliate"
          className="mt-4 px-8 py-3 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold rounded-lg text-lg transition"
        >
          Access my affiliate dashboard
        </a>
        <div className="w-full border-t border-white/10 my-8"></div>
        <h2 className="text-2xl font-semibold mb-2 text-center">Don't have an account yet?</h2>
        <p className="text-slate-300 mb-4 text-center text-base">
          Book a meeting with our team to join the Hiperyon affiliate program:
        </p>
        <a
          href="https://calendly.com/ambroisecainne/30-minute-meeting-clone"
          target="_blank"
          rel="noopener noreferrer"
          className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg text-lg transition hover:-translate-y-0.5 flex items-center gap-2"
        >
          Book a meeting on Calendly
          <span className="ml-2">→</span>
        </a>
      </div>
    </div>
  );
}
